import React from "react";
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  list: {
    position: "relative",
    minHeight: "20px",
    flex:"1 94%",
    alignSelf: "center"
  },
  center: {
    textAlign: "center",
  },
  imgIco: {
    width: "25px",
  },
  title: {
    fontSize: "15px",
    color: "#000",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    fontWeight: 700,
    width: "75%"
  },
  textList: {
    display: "flex",
    alignItems: "center",
    flex: "1 80%"
  },
  ajusteLabel: {
    display: "flex",
    alignItems: "center",
    flex: "1 10%"
  },
  ajusteLabelCota: {
    display: "flex",
    alignItems: "center",
    flex: "1 10%"
  },
  ajusteLabelValor: {
    display: "flex",
    justifyContent: "space-between",
    flex: "1 15%"

  },
  ajusteLabelEndereco: {
    display: "flex",
    alignItems: "center",
    flex: "1 30%"
  },
  titleEmpty: {
    fontSize: 8,
  },

  automaticDebitIcon: {
    width: 10,
  },
  IndicatorIcon: {
    alignSelf: "center",
    display: "flex",
    width: "17px"
  },
  automaticDebitIconModal: {
    width: 16,
    marginRight: 5,
  },
  quota: {
    margin: 0,
    paddingLeft: 7,
  },
  quotaTitle: {
    fontWeight: 500,
  },
  quotaDate: {
    fontSize: 13,
    paddingTop: 4,
  },
  price: {
    fontWeight: "bold",
    color: "#000",
    marginLeft: 5
  },
  descriptionDebit: {
    fontSize: 14,
    margin: 0,
    color: "rgba(0, 0, 0, 0.54)",
  },
  divHiddenIcon: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
  },
  imgHidden: {
    width: "40px",
    height: "40px",
    position: "relative",
    left: "64px"
  },
  stampContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "25%"
  },
  indicadorDam: {
    padding: "5px",
    width: "17px"
  },
  nomeDebito: {
    display: "flex",
    flex: "1 25%",
    alignItems: "center",
    marginLeft: "15px"
  },
  infoContent:{
    display: "flex",
    width: "100%",
    minHeight: "40px"
  }
}));

const useStampClases = makeStyles({
  root: {
    position: "absolute",
    padding: "2px 3px",
    fontWeight: "bold",
    color: ({ color }) => color,
    background: "rgba(255,255,255,0.5)",
    border: "2px solid",
    borderColor: ({ color }) => color,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontSize: "13px"
  },
});

export const Stamp = ({ label, color }) => {
  const classes = useStampClases({ color });

  return <div className={classes.root}>{label}</div>;
};
